export class GHallwaySceneCSS {
    static setVisibilityMain: React.Dispatch<React.SetStateAction<boolean>>;

    static setStartButtonVis: React.Dispatch<React.SetStateAction<boolean>>;
    static setDeviceSupport: React.Dispatch<React.SetStateAction<boolean>>;

    static setNorseSubVisibility: React.Dispatch<React.SetStateAction<boolean>>;
    static setNorseSubQuoteIndex: React.Dispatch<React.SetStateAction<number>>;

    static setTVSubVisibility: React.Dispatch<React.SetStateAction<boolean>>;

    static subtitleTextSetVisible: React.Dispatch<React.SetStateAction<boolean>>;

    static setOceanSubQuoteIndex: React.Dispatch<React.SetStateAction<number>>;
    static guiltTextQuoteIndex: React.Dispatch<React.SetStateAction<number>>;

    static setCurFps: React.Dispatch<React.SetStateAction<number>>;

    static setQualityFooter: React.Dispatch<React.SetStateAction<number>>;

    static questionTextSetVisible: React.Dispatch<React.SetStateAction<boolean>>;
    static guiltTextSetVisible: React.Dispatch<React.SetStateAction<boolean>>;

    static bPageOpen = false;

    static SetNewPage(index: number) {
        this.setPageOpenedOnce(false);
        this.setPageOpen(false);
        this.setPageOpenFooter(false);
        this.setPageIndex(index);
    }

    static setPageOpen: React.Dispatch<React.SetStateAction<boolean>>;
    static setPageOpenFooter: React.Dispatch<React.SetStateAction<boolean>>;
    static setPageIndex: React.Dispatch<React.SetStateAction<number>>;
    static setPageOpenedOnce: React.Dispatch<React.SetStateAction<boolean>>;

    static OceanSubsScript() {
        {
            GHallwaySceneCSS.subtitleTextSetVisible(true);
            GHallwaySceneCSS.setOceanSubQuoteIndex(0);

            const subTimeoutTime = 5;

            setTimeout(() => {
                GHallwaySceneCSS.setOceanSubQuoteIndex(1);

                setTimeout(() => {
                    GHallwaySceneCSS.setOceanSubQuoteIndex(2);

                    setTimeout(() => {
                        GHallwaySceneCSS.setOceanSubQuoteIndex(3);

                        setTimeout(() => {
                            GHallwaySceneCSS.setOceanSubQuoteIndex(4);
                        }, subTimeoutTime * 1000);
                    }, subTimeoutTime * 1000);
                }, subTimeoutTime * 1000);
            }, subTimeoutTime * 1000);
        }
    }

    /*  static setIsVisible: React.Dispatch<React.SetStateAction<boolean>>;
    static setText: React.Dispatch<React.SetStateAction<string>>;

    static ReactShowNewTitle(title: string) {
        if (PayneSceneLightSwitch.setText) {
            PayneSceneLightSwitch.setText(title);
        }
        if (PayneSceneLightSwitch.setIsVisible) {
            PayneSceneLightSwitch.setIsVisible(true);
        }
    }
    static ReactHideTitle() {
        if (PayneSceneLightSwitch.setIsVisible) {
            PayneSceneLightSwitch.setIsVisible(false);
        }
    } */
}
